import { defineComponent as _defineComponent } from 'vue'
import AppBanner from 'ah-common-lib/src/common/components/AppBanner.vue';
import { getPhoneNumber } from 'ah-common-lib/src/helpers/calls';
import { computed, onBeforeMount } from 'vue';
import { useAhTradesState } from '../..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'LimitsProfileWarningBanner',
  setup(__props) {

const tradeState = useAhTradesState();

const requestManager = useRequestManager({
  exposeToParent: true,
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadProfile') {
      loadCurrencyProfile();
    }
  },
});

function loadCurrencyProfile() {
  requestManager.manager.newPromise('loadProfile', tradeState.store.useSettingsStore().loadClientLimitsProfile());
}

onBeforeMount(() => {
  loadCurrencyProfile();
});

const profile = computed(() => tradeState.store.useSettingsStore().clientLimitsProfile);

const tradingDeskPhoneNumber = computed(() => tradeState.theme.tradingDeskPhoneNumber);

const tradingDeskEmail = computed(() => tradeState.theme.tradingDeskEmail);

const tradingDeskEmailUrl = computed(() => {
  return 'mailto:' + tradingDeskEmail.value;
});

return { __sfc: true,tradeState, requestManager, loadCurrencyProfile, profile, tradingDeskPhoneNumber, tradingDeskEmail, tradingDeskEmailUrl, AppBanner, getPhoneNumber }
}

})